export const getScheduleRecordId = function getUniqueId(id) {
    if (isIdInGroup(id)) id = id.split("!").at(-1)
    if (id.endsWith("CS")) id = id.slice(0, -2)
    return extractGlobalId(id)
}

export const isGlobalTailoringId = function isGlobalTailoringId(id, onlyGlobalTailoringIdNotAReferenceToIt) {
    if (onlyGlobalTailoringIdNotAReferenceToIt && id && id.includes("!")) {
        const [groupAndTree] = id.split("!")
        const [group] = groupAndTree.split("~")
        if (group) return false
    }
    return id?.includes("*")
}

export const isIdInGroup = function isIdInGroup(id) {
    return id?.includes("!")
}

export const extractGlobalId = function extractGlobalId(id) {
    if (isGlobalTailoringId(id)) {
        return id.split("*").at(-1)
    }
    return id
}

export const getGroupId = function getGroupId(id) {
    if (isGlobalTailoringId(id, true)) {
        return ""
    }
    if (isIdInGroup(id)) {
        return id.split("!").at(-2).split("~")[0]
    }
    return ""
}

export const getGroupAndTreeId = function getGroupAndTreeId(id) {
    if (isGlobalTailoringId(id, true)) {
        return id.split("*").at(1)
    }
    if (isIdInGroup(id)) {
        return id.split("!").at(-2)
    }
    return ""
}

export const getScheduleId = function getScheduleId(id) {
    return id?.split("!").at(-1)
}

/**
 * Normalizes a group ID by stripping any tree prefix (e.g., ~live|treeId!).
 * This ensures draft and live group IDs can be compared.
 *
 * Examples:
 * - "rVpf3KjzSNxJIT" (draft) → "rVpf3KjzSNxJIT"
 * - "~live|H6AgxnYWsnKnmP!rVpf3KjzSNxJIT" (live) → "rVpf3KjzSNxJIT"
 */
export const normalizeGroupId = function normalizeGroupId(id) {
    if (!id) return id
    // If it contains !, extract the last segment before the schedule separator
    if (id.includes("!")) {
        // For ~live|treeId!groupId, get the part after !
        return id.split("!").at(-1)
    }
    // For draft IDs like rVpf3KjzSNxJIT, return as-is
    return id
}
